import { render, staticRenderFns } from "./transferDialog.vue?vue&type=template&id=771ac3e2&scoped=true"
import script from "./transferDialog.vue?vue&type=script&lang=js"
export * from "./transferDialog.vue?vue&type=script&lang=js"
import style0 from "./transferDialog.vue?vue&type=style&index=0&id=771ac3e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771ac3e2",
  null
  
)

export default component.exports